export default "__VITE_ASSET__d0e56b82__"